// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  DateInconsistenciesParameters,
  getDateInconsistencies,
} from '@/report/api/get-date-inconsistencies';
import { useQuery } from '@tanstack/react-query';

interface UseDateInconsistenciesOptions extends DateInconsistenciesParameters {
  /** Whether the query should fire. Defaults to true. */
  enabled?: boolean;
}

/**
 * A React hook that manages the state of a request for the date inconsistencies report
 * for the current user's organization. This hook retrieves assets with date-related
 * inconsistencies such as dates occurring before inventory dates or assignments before
 * inventory dates.
 */
export function useDateInconsistencies(
  options: UseDateInconsistenciesOptions = {}
) {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['report', 'exception', 'asset', 'date-inconsistencies', params],
    queryFn: () => getDateInconsistencies(params),
    // Disabled: users switch tabs to complete resolution tasks, and we don't
    // want to trigger expensive refetches when they return. Optimistic UI
    // handles the immediate feedback; data syncs on page refresh or navigation.
    refetchOnWindowFocus: false,
    enabled,
  });
}
